<app-loader [isLoader]="loader"></app-loader>
<section class="page-gutter">
    <div class="portlet-container">
        <div class="portlet-head">
            <div class="title-block">
                <h2>Review Permissions</h2>
                <p>Approve or reject requested segment updates</p>
            </div>
            <div class="action toolbar-actions">
                <div class="search-box margin">
                    <img [src]="searchIcon" />
                    <input class="form-control" type="text" placeholder="Search by segment name"
                        [(ngModel)]="filter.search" (input)="onSearch($event)" />
                </div>
                <button class="btn default fw-semi margin" (click)="openFilter()">
                    <img [src]="filterIcon" class="filter-icon" alt="filter">
                    Filters
                </button>
            </div>
        </div>
        <div class="portlet-body">
            <div class="filter-gutter" [ngClass]="{'opened': toggleFilter}">
                  <app-filter-shared-dropdown [title]="'Segment Type'" [items]="segmentTypeList"
                    [selectedItems]="filter.segment_type" (clearAll)="clearFilterDropdown('segment_type')"
                    (selectAllChange)="selectFilterDrowDownItem($event,'segment_type')"
                    (itemChecked)="isItemChecked($event,'segment_type')"></app-filter-shared-dropdown>
                <app-filter-shared-dropdown [title]="'Status'" [items]="statusList" [selectedItems]="filter.status"
                    (clearAll)="clearFilterDropdown('status')"
                    (selectAllChange)="selectFilterDrowDownItem($event,'status')"
                    (itemChecked)="isItemChecked($event,'status')"></app-filter-shared-dropdown>
                <app-filter-shared-dropdown [title]="'Provider Element'" [items]="providerElementList" [selectedItems]="filter.providerElementIds"
                    (clearAll)="clearFilterDropdown('providerElementIds')"
                    (selectAllChange)="selectFilterDrowDownItem($event,'providerElementIds')"
                    (itemChecked)="isItemChecked($event,'providerElementIds')"></app-filter-shared-dropdown>
                <app-filter-shared-dropdown [title]="'Partner Id'" [items]="partnerList" [selectedItems]="filter.partnerIds"
                    (clearAll)="clearFilterDropdown('partnerIds')"
                    (selectAllChange)="selectFilterDrowDownItem($event,'partnerIds')"
                    (itemChecked)="isItemChecked($event,'partnerIds')"></app-filter-shared-dropdown>
                <button class="no-btn clear" (click)="clearFilter()">Clear all</button>
            </div>

            @if(approvalSegmentList.length > 0){
            <div class="table-container" [ngClass]="{'active-filter': !toggleFilter}">
                <table class="table primary-table">
                    <thead>
                        <tr>
                            <th class="sorting" >
                                <span class="sortable" (click)="sorting('segmentName')">
                                    <span class="label">Segment Name</span>
                                    <div class="sort-arrows">
                                        <div class="sort-arrow up" 
                                            [class.active]="sortingKey === 'segmentName' && sortingValue === 'ASC'">
                                        </div>
                                        <div class="sort-arrow down"
                                            [class.active]="sortingKey === 'segmentName' && sortingValue === 'DESC'">
                                        </div>
                                    </div>
                                </span>
                            </th>
                            <th class="col-center">
                                Segment Type
                            </th>
                            <th>Segment Id</th>
                            <th>Provider Element Id</th>
                            <th class="col-center">Status</th>
                            <th class="sorting">
                                <span class="sortable" (click)="sorting('createdAt')">
                                    <span class="label">Created At</span>
                                    <div class="sort-arrows">
                                        <div class="sort-arrow up" 
                                            [class.active]="sortingKey === 'createdAt' && sortingValue === 'ASC'">
                                        </div>
                                        <div class="sort-arrow down"
                                            [class.active]="sortingKey === 'createdAt' && sortingValue === 'DESC'">
                                        </div>
                                    </div>
                                </span>
                            </th>
                            <th>Created By</th>
                            <th class="action-header">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(segment of approvalSegmentList; track $index){
                        <tr>
                            <td>
                                <span class="segment-name" [title]="segment.name + ' (' + (segment.ttd_identifeir || '-') + ')'">
                                    {{segment.name || '-'}}
                                </span>
                            </td>
                            <td class="col-center">
                                <span class="segment-type-chip"
                                    [ngClass]="getSegmentTypeChipClass(segment.segment_type)">
                                    {{(segment.segment_type  | upperCase) || 'Standard' }}
                                </span>
                            </td>
                            <td>
                                {{segment.segment_id}}
                            </td>
                            <td>
                                {{segment.provider_element_id || '-'}}
                            </td>
    
                            <td class="col-center">
                                <span class="status-chip" [ngClass]="getStatusChipClass(segment.status)">
                                    {{segment.status | upperCase}}
                                </span>
                            </td>
                            <td>{{segment.created_at | date}}</td>
                            <td>{{segment.created_by.name || '-'}}</td>
                            <!-- <td>{{(segment.approved_at | date) || '-'}}</td>

                            <td>{{segment.approved_by.name || '-'}}</td> -->
                            <td>
                                <div class="action-dropdown">
                                    <button class="dropdown-trigger" (click)="toggleDropdown($index)">
                                        <img src="assets/img/verticle.svg" alt="More options" class="dropdown-icon">
                                    </button>
                                    <div class="dropdown-menu" [class.show]="activeDropdownIndex === $index">
                                        <!-- <div class="dropdown-item" (click)="EditSegment(segment.id)">
                                            <img src="assets/img/edit.svg" alt="Edit" class="dropdown-icon">
                                            <span>Edit Segment</span>
                                        </div> -->
                                        <div class="dropdown-item" (click)="openChangeStatusModal(segment)">
                                            <img src="assets/img/edit.svg" alt="Change Status" class="dropdown-icon">
                                            <span>Change Status</span>
                                        </div>

                                    </div>
                                </div>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
            }

            @if(approvalSegmentList.length > 0){
            <div class="fix-pagination">
                <app-custom-pagination [filter]="filter" [total]="totalCount"
                    (savePage)="fetchUserDataByPage($event)"></app-custom-pagination>
            </div>
            }
            @if(approvalSegmentList.length == 0 && loader == false){
            <app-no-data [noData]="false" [heading1]="'No Segment Found!'" [title]="'segment'"></app-no-data>
            }
        </div>
    </div>
</section>

<!-- Shared Modal for Segment Status Change -->
<app-shared-modal 
    [modalConfig]="segmentStatusModalConfig" 
    (confirm)="onSegmentStatusConfirm($event)" 
    (cancel)="onSegmentStatusCancel()">
</app-shared-modal>